import React, {useState, useContext, useEffect} from "react";
import Table from "../../../components/table/Tables";
import AppLoader, {LoadComponet} from "../../../components/loaders/Loader";
import ShowCourseModal from "./ShowModal";
import DeleteModal from "../../../components/modals/DeleteModal";
import {PrimeContext} from "../../../context/PrimeProvider";
import {Grid, Col} from "../../../styles/Grid";
import {ReactComponent as PlusIcon} from "../../../assets/icons/plus.svg";
import {ButtonWithIcon} from "../../../styles/Butttons";
import {useHistory} from "react-router-dom";
import HeadView from "../../../containers/HeadView";
import {PageWebUrl} from "../../../services/ApiUrl";

export default function MasterclassList({theme, toggleChange, deleteItem}) {
   const {getMasterclass, masterclassData, isLoading, deleteCoursePrime, isSaving} = useContext(PrimeContext);
   const [showModal, setShowModal] = useState({isOpen: false, data: {}});
   const [deleteModal, setDeleteModal] = useState({isOpen: false, id: "", url: ""});
   let history = useHistory();

   useEffect(() => {
      getMasterclass();
   }, []);

   const saveDelete = () => {
      deleteCoursePrime(deleteModal.id, 5);
      setDeleteModal({isOpen: false, data: {}, id: "", url: ""});
   };

   return (
      <>
         {isLoading.masterclass ? (
            <LoadComponet isVisible={true} theme={theme} />
         ) : (
            <>
               <HeadView>
                  <></>
                  <>
                     <ButtonWithIcon
                        action={() => {
                           history.push("/offer/add/5");
                        }}
                        text="Crear nuevo masterclass"
                        Icon={PlusIcon}
                     />
                  </>
               </HeadView>
               <Table
                  theme={theme}
                  data={masterclassData}
                  toggleChange={toggleChange}
                  showModal={(info) => {
                     setShowModal({isOpen: true, data: info, type: "info", title: "Información De curso esencial"});
                  }}
                  deleteModal={(course) => {
                     setDeleteModal({isOpen: true, id: course.idCourse, url: "google.com"});
                  }}
                  viewAction={(item) => {
                     let newxtUrl = PageWebUrl + "masterclass/" + item.idCourse;
                     window.open(newxtUrl, "_blank");
                  }}
                  editModal={(item) => {
                     history.push(`/offer/edit/${item.idCourseType}/${item.idCourse}`, {prev: "/offer/certificado_prime"});
                  }}
                  columns={Columns}
               />
            </>
         )}
         <ShowCourseModal
            isOpen={showModal.isOpen}
            close={() => {
               setShowModal(false);
            }}
            theme={theme}
            type={showModal.type}
            title={showModal.title}
            data={showModal.data}
         />
         <DeleteModal
            isOpen={deleteModal.isOpen}
            close={() => {
               setDeleteModal({isOpen: false, data: {}, id: "", url: ""});
            }}
            id={deleteModal.id}
            url={deleteModal.url}
            theme={theme}
            confirm={saveDelete}
            //, save, id, url
         />
         <AppLoader isVisible={isSaving} />
      </>
   );
}
const Columns = [
   {
      title: "Nombre",
      accessor: "courseName",
      action: "showModal",
   },
   {
      title: "Duración",
      accessor: "endDate",
   },
   {
      title: "Código de curso",
      accessor: "courseCode",
   },
   {
      title: "Fecha de inicio",
      accessor: "startDate",
   },
   /*   {
      title: "Añadir a Home",
      class: "actionBtn ghost",
      component: "toggle",
      // accessor: "onhome",
   }, 
   {
      title: "Añadir a la página",
      class: "actionBtn ghost",
      component: "toggle",
      accessor: "onpage",
   },*/
   {
      title: "Vista en página",
      class: "actionBtn ghost",
      component: "view",
   },
   /* {
      title: "",
      class: "actionBtn ghost",
      component: "show",
   }, */
   {
      title: "",
      class: "actionBtn ghost",
      component: "edit",
   },
   {
      title: "",
      class: "actionBtn ghost",
      component: "delete",
   },
];
